import styled from 'styled-components';

export const Container = styled.section`
    display: flex;
    flex-direction: column;
    min-height: 660px;
    background-color: #121212;
    border-radius: 5px;
    box-sizing: border-box;
    width: 100%;
    max-width: 650px;
    padding: 60px 68px 40px;
    margin-bottom: 100px;

    @media screen and (max-width: 667px){
        width: 100%;
    }
`;

export const Error = styled.div`
    background: #e87c03;
    border-radius: 4px;
    font-size: 14px;
    margin: 0 0 16px;
    color: white;
    padding: 15px 20px;
`;

export const Base = styled.form`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 500px;
    margin: 56px 0;

`;

export const Title = styled.h1`
    position: relative;
    color: #fff;
    font-size: 8rem;
    text-align: right;
    font-weight: bold;
    font-style: italic;
    line-height: 6rem;

    &:after{
        content: "";
        display: block;
        width: 45%;
        height: 5px;
        background: #FFF;
        left: 85px;
        bottom: 20%;
        position: absolute;
    }

    @media screen and (max-width: 667px){
        font-size: 4rem;
        line-height: 3rem;
        text-align: center;

        &:after{
        content: "";
        display: block;
        width: 150px;
        height: 3px;
        bottom: -20px;
        background: #FFF;
        text-align: center;
        position: absolute;
    }
    }
`;

export const Input = styled.input`
    background: #333;
    border-radius: 4px;
    border: 0;
    color: #fff;
    height: 50px;
    line-height: 50px;
    padding: 5px 20px;
    margin-bottom: 20px;
    
    &:last-of-type {
        margin-bottom: 30px;
    }
`;

export const TextArea = styled.textarea`
    background: #333;
    border-radius: 4px;
    max-width: 500px;
    border: 0;
    color: #fff;
    height: 120px;
    padding: 5px 10px;
    margin-bottom: 20px;
    overflow: hidden;
    font-size: 16px;
    
    &:last-of-type {
        margin-bottom: 30px;
    }
`;

export const Submit = styled.input`
    background: #D6D6D7;
    border-radius: 4px;
    font-size: 16px;
    font-weight: bold;
    padding: 16px;
    border: 0;
    color: black;
    cursor: pointer;

    &:hover{
        background: #5f27cd;
        color: #D6D6D7;
    }
    
    &:disabled {
        opacity: 0.5;
    }

`;